module.exports = __webpack_public_path__ + "img/credit_blue_icon.73d200a1.svg";